import { render, staticRenderFns } from "./FooterLogin.vue?vue&type=template&id=25030103&scoped=true&"
import script from "./FooterLogin.vue?vue&type=script&lang=js&"
export * from "./FooterLogin.vue?vue&type=script&lang=js&"
import style0 from "./FooterLogin.vue?vue&type=style&index=0&id=25030103&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25030103",
  null
  
)

export default component.exports